import { COLORS } from 'constants/index';
import typography from '../typography';

const MuiInputAdornment = {
  positionStart: {
    ...typography.body1,
    color: COLORS.BLACK_6
  }
};

export default MuiInputAdornment;
